import { render, staticRenderFns } from "./Step2Toiture.vue?vue&type=template&id=2b940916&scoped=true"
import script from "./Step2Toiture.vue?vue&type=script&lang=js"
export * from "./Step2Toiture.vue?vue&type=script&lang=js"
import style0 from "./Step2Toiture.vue?vue&type=style&index=0&id=2b940916&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b940916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b940916')) {
      api.createRecord('2b940916', component.options)
    } else {
      api.reload('2b940916', component.options)
    }
    module.hot.accept("./Step2Toiture.vue?vue&type=template&id=2b940916&scoped=true", function () {
      api.rerender('2b940916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/Step2Toiture.vue"
export default component.exports